import styled from "styled-components";

export const PreviewWrapper = styled.div`
    overflow-x: auto;
    margin: 1rem 0;
`;

export const PreviewTable = styled.table`
    border-collapse: collapse;
    min-width: 100%;

    th,
    td {
        max-width: 24rem;
        overflow: hidden;
        border: 1px solid #ddd;
        padding: 0.5rem;
        text-align: left;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    th {
        background-color: #f2f2f2;
    }

    tr[data-header-row="true"] {
        background-color: #f9f9f9;
        color: #666;
        font-style: italic;
    }
`;
